export default {"src":"/_next/static/media/grey-cross.f203222d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};